// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-form {
    margin-top:10vh !important;
    padding: 32px;
    background-color: white !important;
    width: 320px;
    width: var(--login-div-size, 320px);
    margin: auto;
}

.totp-header {
    display: flex;
    align-items: center;
    justify-content: center;
}

.totp-back-button {
    margin-right: 10px;
    margin-bottom: 10px;
    font-size: 24px; 
  }

.login-logo-totp {
    margin: auto;
    display: block;
    margin-bottom: 12px;
    padding-right: 34px;
    background-color: white !important;
    border-radius: 16px !important;
    height: auto;
    width: 30%;
} 
  
.login-logo {
    margin: auto;
    display: block;
    margin-bottom: 12px;
    background-color: white !important;
    border-radius: 16px !important;
    height: auto;
    width: 30%;
}

.login-form-button {
    height: 45px !important;
    width: 100%;
    margin-top: 1%;
    background-color: #330470;
    border-color: #330470;
}

.login-form-button:hover {
    background-color: #006090;
    border-color: #006090;
}

.demo-login {
    text-align: center;
    font-size: 12px;
}

.logout-message {
    text-align: center;
    margin: auto;
    padding: 10px;
}

.totp-container {
    display: block;
    align-items: center;
    justify-content: center;
    text-align: center; 
    padding: 20px
}

.totp-info {
    padding-top: 16px;
    padding-bottom: 20px ;
    font-size: 16px;
    text-align: center;
}
.totp-info-bottom {
    padding-top: 10px;
    margin-bottom: 10px;
    font-size: 16px;
    text-align: center;
}

`, "",{"version":3,"sources":["webpack://./src/asset/style/login.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B,aAAa;IACb,kCAAkC;IAClC,YAAY;IACZ,mCAAmC;IACnC,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;EACjB;;AAEF;IACI,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,kCAAkC;IAClC,8BAA8B;IAC9B,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,kCAAkC;IAClC,8BAA8B;IAC9B,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB","sourcesContent":[".login-form {\n    margin-top:10vh !important;\n    padding: 32px;\n    background-color: white !important;\n    width: 320px;\n    width: var(--login-div-size, 320px);\n    margin: auto;\n}\n\n.totp-header {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.totp-back-button {\n    margin-right: 10px;\n    margin-bottom: 10px;\n    font-size: 24px; \n  }\n\n.login-logo-totp {\n    margin: auto;\n    display: block;\n    margin-bottom: 12px;\n    padding-right: 34px;\n    background-color: white !important;\n    border-radius: 16px !important;\n    height: auto;\n    width: 30%;\n} \n  \n.login-logo {\n    margin: auto;\n    display: block;\n    margin-bottom: 12px;\n    background-color: white !important;\n    border-radius: 16px !important;\n    height: auto;\n    width: 30%;\n}\n\n.login-form-button {\n    height: 45px !important;\n    width: 100%;\n    margin-top: 1%;\n    background-color: #330470;\n    border-color: #330470;\n}\n\n.login-form-button:hover {\n    background-color: #006090;\n    border-color: #006090;\n}\n\n.demo-login {\n    text-align: center;\n    font-size: 12px;\n}\n\n.logout-message {\n    text-align: center;\n    margin: auto;\n    padding: 10px;\n}\n\n.totp-container {\n    display: block;\n    align-items: center;\n    justify-content: center;\n    text-align: center; \n    padding: 20px\n}\n\n.totp-info {\n    padding-top: 16px;\n    padding-bottom: 20px ;\n    font-size: 16px;\n    text-align: center;\n}\n.totp-info-bottom {\n    padding-top: 10px;\n    margin-bottom: 10px;\n    font-size: 16px;\n    text-align: center;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
